import { signUp } from "aws-amplify/auth";
import { configureAmplify } from "../amplifyConfig"; // Import the configuration

// Pipeline test: Testing GitHub Actions deployment workflow
// Ensure that Amplify is configured when the service is imported
configureAmplify();

// Define the function to submit the user form
export const submitUserForm = async (data: { 
  username: string; 
  email: string; 
  consent: boolean;
  twitterHandle: string;
  password: string;
  inviteOrigin: string;
}) => {
  try {
    // Using Amplify Auth's signUp method to register the user
    const signUpResult = await signUp({
      username: data.email,  // Use email as the login username
      password: data.password,  // Password entered by the user
      options: {
        userAttributes: {
          email: data.email,  // Standard attribute for email
          preferred_username: data.username,  // Unique preferred_username
          'custom:consent': String(data.consent),  // Custom attribute for consent (as a string)
          'custom:twitter_handle': data.twitterHandle,  // Custom attribute for tweet link (url)
          'custom:invite_origin': data.inviteOrigin,  // Custom attribute for invite origin
        },
      },
    });

    const { isSignUpComplete, nextStep } = signUpResult;
    return { success: true, isSignUpComplete, nextStep };
    
  } catch (error: any) {
    console.error('Error during sign-up:', error);
    throw new Error(error.message || 'Sign-up failed.');
  }
};
